/** Split a tag/keyword input into individual values (comma, semicolon, or newline separated). */
export function parseTagInput(raw: string): string[] {
  return raw
    .split(/[,;\n]+/)
    .map((value) => value.trim())
    .filter(Boolean)
}

/** Merge new tags into an existing list without duplicates (case-sensitive). */
export function mergeUniqueTags(existing: string[], incoming: string[]): string[] {
  const merged = [...existing]
  for (const tag of incoming) {
    const trimmed = tag.trim()
    if (trimmed && !merged.includes(trimmed)) {
      merged.push(trimmed)
    }
  }
  return merged
}
